'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var generateAction = require('@piconetworks/generate-action');
var produce = require('immer');
var effects = require('redux-saga/effects');
var endpoints = require('@piconetworks/endpoints');
var networkMiddleware = require('@piconetworks/network-middleware');
var Duck = require('extensible-duck');
var reselect = require('reselect');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var generateAction__default = /*#__PURE__*/_interopDefaultLegacy(generateAction);
var produce__default = /*#__PURE__*/_interopDefaultLegacy(produce);
var Duck__default = /*#__PURE__*/_interopDefaultLegacy(Duck);

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var getDefaultLandingPage$1 = generateAction__default['default']({
  baseActionCreatorName: 'getDefaultLandingPage',
  baseActionTypeName: 'GET_DEFAULT_LANDING_PAGE'
});
var getLandingPage$1 = generateAction__default['default']({
  baseActionCreatorName: 'getLandingPage',
  baseActionTypeName: 'GET_LANDING_PAGE'
});
var getDefaultPopup = generateAction__default['default']({
  baseActionCreatorName: 'getDefaultPopup',
  baseActionTypeName: 'GET_DEFAULT_POPUP'
});
var getPopup$2 = generateAction__default['default']({
  baseActionCreatorName: 'getPopup',
  baseActionTypeName: 'GET_POPUP'
});
var types = [].concat(_toConsumableArray(getDefaultLandingPage$1.types), _toConsumableArray(getLandingPage$1.types), _toConsumableArray(getDefaultPopup.types), _toConsumableArray(getPopup$2.types));

var creators = function creators(duck) {
  return Object.assign({}, getDefaultLandingPage$1.creators(duck), getLandingPage$1.creators(duck), getDefaultPopup.creators(duck), getPopup$2.creators(duck));
};

var initialState = {
  landingPages: {
    data: [],
    error: null
  },
  popups: {
    data: [],
    error: null
  },
  defaultPopup: null,
  defaultLandingPage: null,
  defaultPaymentLandingPage: null
};

var reducer = function reducer(state, _ref, duck) {
  var type = _ref.type,
      payload = _ref.payload,
      error = _ref.error;
  return produce__default['default'](state, function (draftState) {
    switch (type) {
      case duck.types.GET_LANDING_PAGE_SUCCESS:
        draftState.landingPages.data = payload;
        break;

      case duck.types.GET_DEFAULT_LANDING_PAGE_SUCCESS:
        draftState.defaultLandingPage = payload.defaultLandingPage;
        draftState.defaultPaymentLandingPage = payload.defaultLandingPage;
        break;

      case duck.types.GET_LANDING_PAGE_ERROR:
        draftState.landingPages.error = error;
        break;

      case duck.types.GET_DEFAULT_POPUP_SUCCESS:
        draftState.defaultPopup = payload.defaultPopup;
        break;

      case duck.types.GET_POPUP_SUCCESS:
        draftState.popups.data = payload;
        break;

      case duck.types.GET_POPUP_ERROR:
        draftState.popups.error = error;
        break;

    }
  });
};

function* getDefaultLandingPage(_ref) {
  var types = _ref.types,
      publisherName = _ref.payload;

  try {
    var _yield$call = yield effects.call(networkMiddleware.picoAPIHelper, {
      url: "".concat(endpoints.FORMS_LANDING_PAGE(), "/").concat(publisherName),
      method: 'get'
    }),
        data = _yield$call.data;

    if (data) {
      yield effects.put({
        type: types.GET_DEFAULT_LANDING_PAGE_SUCCESS,
        payload: data
      });
    } else {
      throw new Error('unable to fetch default landing page');
    }
  } catch (error) {
    yield effects.put({
      type: types.GET_DEFAULT_LANDING_PAGE_ERROR,
      error: (error === null || error === void 0 ? void 0 : error.message) || 'GET_DEFAULT_LANDING_PAGE_ERROR'
    });
  }
}

function* getLandingPage(_ref) {
  var types = _ref.types,
      _ref$payload = _ref.payload,
      publisherName = _ref$payload.publisherName,
      shortcode = _ref$payload.shortcode;

  try {
    var _yield$call = yield effects.call(networkMiddleware.picoAPIHelper, {
      url: "".concat(endpoints.FORMS_LANDING_PAGE(), "/").concat(publisherName, "/").concat(shortcode),
      method: 'get'
    }),
        data = _yield$call.data;

    if (data) {
      yield effects.put({
        type: types.GET_LANDING_PAGE_SUCCESS,
        payload: data
      });
    } else {
      throw new Error('unable to fetch landing page');
    }
  } catch (error) {
    yield effects.put({
      type: types.GET_LANDING_PAGE_ERROR,
      error: (error === null || error === void 0 ? void 0 : error.message) || 'GET_LANDING_PAGE_ERROR'
    });
  }
}

function* getPopup$1(_ref) {
  var types = _ref.types,
      publisherName = _ref.payload;

  try {
    var _yield$call = yield effects.call(networkMiddleware.picoAPIHelper, {
      url: "".concat(endpoints.FORMS_POPUP(), "/").concat(publisherName),
      method: 'get'
    }),
        data = _yield$call.data;

    if (data) {
      yield effects.put({
        type: types.GET_DEFAULT_POPUP_SUCCESS,
        payload: data
      });
    } else {
      throw new Error('unable to fetch default popup');
    }
  } catch (error) {
    yield effects.put({
      type: types.GET_DEFAULT_POPUP_ERROR,
      error: (error === null || error === void 0 ? void 0 : error.message) || 'GET_DEFAULT_POPUP_ERROR'
    });
  }
}

function* getPopup(_ref) {
  var types = _ref.types,
      _ref$payload = _ref.payload,
      publisherName = _ref$payload.publisherName,
      shortcode = _ref$payload.shortcode;

  try {
    var _yield$call = yield effects.call(networkMiddleware.picoAPIHelper, {
      url: "".concat(endpoints.FORMS_POPUP(), "/").concat(publisherName, "/").concat(shortcode),
      method: 'get'
    }),
        data = _yield$call.data;

    if (data) {
      yield effects.put({
        type: types.GET_POPUP_SUCCESS,
        payload: data
      });
    } else {
      throw new Error('unable to fetch popup');
    }
  } catch (error) {
    yield effects.put({
      type: types.GET_POPUP_ERROR,
      error: (error === null || error === void 0 ? void 0 : error.message) || 'GET_POPUP_ERROR'
    });
  }
}

var sagas = function sagas(duck) {
  return {
    getDefaultLandingPage: function* getDefaultLandingPage$1(payload) {
      yield getDefaultLandingPage(Object.assign({}, payload, duck));
    },
    getLandingPage: function* getLandingPage$1(payload) {
      yield getLandingPage(Object.assign({}, payload, duck));
    },
    getDefaultPopup: function* getDefaultPopup(payload) {
      yield getPopup$1(Object.assign({}, payload, duck));
    },
    getPopup: function* getPopup$1(payload) {
      yield getPopup(Object.assign({}, payload, duck));
    }
  };
};

var takes = function takes(_ref) {
  var types = _ref.types,
      sagas = _ref.sagas;
  return [effects.takeEvery(types.GET_DEFAULT_LANDING_PAGE, sagas.getDefaultLandingPage), effects.takeEvery(types.GET_LANDING_PAGE, sagas.getLandingPage), effects.takeEvery(types.GET_DEFAULT_POPUP, sagas.getDefaultPopup), effects.takeEvery(types.GET_POPUP, sagas.getPopup)];
};

var selectors = function selectors() {
  return {
    forms: new Duck__default['default'].Selector(function () {
      return function (state) {
        return state === null || state === void 0 ? void 0 : state.forms;
      };
    }),
    getLandingPage: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.forms, function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            landingPage = _ref.landingPage;

        return landingPage.data;
      });
    }),
    getPopup: new Duck__default['default'].Selector(function (selectors) {
      return reselect.createSelector(selectors.forms, function () {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            popup = _ref2.popup;

        return popup.data;
      });
    })
  };
};

var store = 'forms';
var index = (function (_ref) {
  var createDuck = _ref.createDuck;
  return createDuck({
    store: store,
    initialState: initialState
  }).extend({
    creators: creators,
    types: types,
    reducer: reducer,
    sagas: sagas,
    takes: takes,
    selectors: selectors
  });
});

exports.creators = creators;
exports.default = index;
exports.initialState = initialState;
exports.reducer = reducer;
exports.sagas = sagas;
exports.store = store;
exports.takes = takes;
exports.types = types;
